<template>
  <AdblockTopbar />
  <div class="px-4 max-w-screen-xl lg:mx-auto">
    <HeaderApp />

    <div class="relative py-10 sm:py-0">
      <button
        @click="backToInitial()"
        class="cursor-pointer z-10 absolute top-0 mt-0 sm:mt-3 left-0 flex justify-center w-8 h-8 rounded-full bg-gray-200 p-1 focus:outline-none duration-300 hover:bg-gray-300"
      >
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="rgb(79 70 229)"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
      <div class="flex flex-col justify-center text-center my-5">
        <h1 class="font-semibold text-2xl my-5">
          {{ ugc_creator_title_subtitle.title }}
        </h1>
      </div>
    </div>

    <div
      class="bg-white rounded-2xl border flex items-center justify-center py-10 px-4 mx-4 sm:px-2 lg:px-8"
    >
      <div>
        <div class="flex items-center justify-center gap-2 mt-2">
          <img
            :src="selectedUgcCreator.profile_picture"
            class="w-20 h-25 rounded-full"
          />
        </div>

        <div class="flex items-center justify-center gap-2 mt-2">
          <h3 class="font-semibold mt-2">{{ selectedUgcCreator.name }}</h3>
        </div>
        <div class="flex items-center justify-center gap-2 mt-2">
          <span class="text-lg py-5 px-2 bg-gray-100">{{
            selectedUgcCreator.industry
          }}</span>
        </div>
        <div
          class="flex flex-row justify-center items-center content-center gap-2 mt-2"
        >
          <span
            class="flex justify-center items-center content-center rounded-lg font-semibold text-sm"
          >
            <Icon name="Location" viewbox="0 0 18 21" stroke="" class="w-5" />
            <p class="text-xs ml-1 font-medium text-606770">
              {{ selectedUgcCreator.country }}
            </p>
          </span>

          <span
            class="mx-3 flex justify-center items-center content-center rounded-lg font-semibold text-sm"
          >
            <Icon
              name="CurrencyUsd"
              viewbox="0 0 20 20"
              class="w-5"
              fill="#5F5DC5"
              stroke="none"
            />&nbsp;
            <p class="text-xs ml-1 font-medium text-606770">
              {{ selectedUgcCreator.minimum_price }}
            </p>
          </span>

          <a
            v-if="selectedUgcCreator.twitter_link"
            :href="selectedUgcCreator.twitter_link"
            target="_blank"
            class="cursor-pointer w-8 h-8 flex justify-center border rounded-full border-gray-400 p-1 hover:border-indigo-600 hover:bg-indigo-600 text-indigo-600 hover:text-white duration-500"
          >
            <Icon
              name="Twitter"
              viewbox="0 0 20 16"
              class="w-4 fill-current"
              stroke="none"
              fill="rgb(160,174,196)"
            />
          </a>
          <a
            v-if="selectedUgcCreator.website"
            :href="selectedUgcCreator.website"
            target="_blank"
            class="cursor-pointer w-8 h-8 flex justify-center border rounded-full border-gray-400 p-1 hover:border-indigo-600 hover:bg-indigo-600 text-indigo-600 hover:text-white duration-500"
          >
            <Icon
              name="Web"
              viewbox="0 0 24 24"
              class="w-4 fill-current"
              stroke="none"
            />
          </a>
          <a
            v-if="selectedUgcCreator.tiktok_link"
            :href="selectedUgcCreator.tiktok_link"
            target="_blank"
            class="cursor-pointer w-8 h-8 flex justify-center border rounded-full border-gray-400 p-1 hover:border-indigo-600 hover:bg-indigo-600 text-indigo-600 hover:text-white duration-500"
          >
            <Icon
              name="Tiktok"
              fill="rgb(160,174,196)"
              viewbox="0 0 32 32"
              class="w-4 fill-current"
              stroke="#cecece"
            />
          </a>
        </div>
      </div>
    </div>
    <div class="library__list py-4 lg:py-10 items-start">
      <div v-for="(video, index) of selectedUgcCreator.videos" :key="index">
        <div class="relative">
          <div class="square">
            <video class="w-full" controls>
              <source :src="video" />
            </video>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onBeforeMount } from "vue";
import { useStore } from "vuex";
import HeaderApp from "@/components/Header";
import { useRouter } from "vue-router";
import Icon from "@/components/UI/Icon";

export default {
  components: { HeaderApp, Icon },
  props: {
    lock: Boolean,
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    const selectedUgcCreator = computed(() => store.state.selectedUgcCreator);
    const ugc_creator_title_subtitle = computed(
      () => store.state.ugcCreatorsTitleSubtitle
    );
    const backToInitial = () => {
      router.push("/ugc-creators");
    };

    onBeforeMount(async () => {
      const status = computed(() => store.state.status);
      if (!status.value) {
            console.log("1")

        router.push("/pricing");
      }

      if (!selectedUgcCreator.value) {
        window.location.href =
          process.env.VUE_APP_ADBOX_APP_FRONT_URL + "/ugc-creators";
      }
    });

    return {
      selectedUgcCreator,
      ugc_creator_title_subtitle,
      backToInitial,
    };
  },
};
</script>

<style>
.lock {
  filter: blur(18px);
  pointer-events: none;
}

.wrapper__info-ad {
  @apply grid-cols-1;
  display: grid;
  gap: 20px;
}
@screen sm {
  .wrapper__info-ad {
    grid-template-columns: 0.5fr 1fr;
  }
}
.info-ad__text {
  background-image: linear-gradient(
    to right,
    rgba(252, 252, 252, 0.87),
    rgba(102, 126, 234, 0.342)
  );
  border-radius: 20px;
}
.button__change {
  top: 50%;
}
.text__center {
  left: 50%;
  right: 50%;
  margin-left: -2em;
}
.library__list {
  @apply grid gap-y-10 gap-x-10;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fit, minmax(19rem, 22rem));
}
.library__item {
  max-width: 24rem;
  min-width: 18rem;
  width: 100%;
}
</style>
